let moduleFunc = require.context('../common', true, /com\.jsx$/);

export default { ...moduleFunc.keys().map(item => ({
    [item.split('/')[1][0].toUpperCase() + item.split('/')[1].slice(1)]: moduleFunc(item).default
  })).reduce((pre, next) => ({ ...pre,
    ...next
  }))
};